import {
  HOME_META_DESCRIPTION,
  HOME_META_TITLE,
  HOME_META_IMAGE,
  HOME_META_VIDEO,
  FB_APP_ID,
  TWITTER_HANDLE
} from 'constants';
import { useRouter } from 'next/router';
import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

const PageHead = ({
  title,
  description,
  image,
  video,
  url,
  children
}) => {
  const router = useRouter();
  const canonical = url || `${process.env.NEXT_PUBLIC_APP_ROOT}${router.asPath}`;
  const versionedImage = `${image}?v=1.3`;
  return (
    <Head>
      <title>{title}</title>
      <meta property="og:type" content="website" />
      <meta property="og:image" content={versionedImage} key="ogimage" />
      <meta property="og:video" content={video} />
      <meta property="og:site_name" content="Scribble Art" key="ogsitename" />
      <meta property="og:title" content={title} key="ogtitle" />
      <meta property="og:description" content={description} key="ogdesc" />
      <meta name="description" content={description} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
      <meta property="fb:app_id" content={FB_APP_ID} />
      {url !== false && (
        <>
          <meta property="og:url" content={canonical} key="ogurl" />
          <link href={canonical} rel="canonical" />
        </>
      )}
      {children}
    </Head>
  );
};

PageHead.defaultProps = {
  title: HOME_META_TITLE,
  description: HOME_META_DESCRIPTION,
  image: HOME_META_IMAGE,
  video: HOME_META_VIDEO,
  url: undefined,
  children: null
};

PageHead.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  description: PropTypes.string,
  image: PropTypes.string,
  video: PropTypes.string,
  url: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};

export default PageHead;
